module.exports = __webpack_public_path__ + "static/media/ACALogo(1016pxWide)_1730987830637.3fb74346.eps";